import React from 'react'
import './Reviewsec.css'
import img from '../../assets/others/11102031.png'
import userimg from '../../assets/others/user.png'
import img1 from '../../assets/reviews/Thikkala sanjay kumar.jpg'
import img2 from '../../assets/reviews/TATA VENKATA SRI RAJENDRA PRASAD.jpg'
import img3 from '../../assets/reviews/Vemula sarika.jpg'
import img4 from '../../assets/reviews/P BHASKAR REDDY.jpg'
import img5 from '../../assets/reviews/Boggavarapu Ravi Sankar gupta.jpg'
import img6 from '../../assets/reviews/Laam Jana Priya.jpg'
import img7 from '../../assets/reviews/Nerella Venkata Sai Samyuktha.jpg'
import img8 from '../../assets/reviews/Ravindra Kumar Maurya.jpg'
import img9 from '../../assets/reviews/Merva Pranavi .jpg'
import img10 from '../../assets/reviews/Samyuktha Shrruthi K R.jpg'
import c1 from '../../assets/c-logo/8.png'
import c2 from '../../assets/c-logo/3.png'
import c3 from '../../assets/c-logo/7.png'
import c4 from '../../assets/c-logo/2.svg'
import c5 from '../../assets/c-logo/apex.png'
import c6 from '../../assets/c-logo/4.png'
import c7 from '../../assets/c-logo/4.png'
import c8 from '../../assets/c-logo/6.png'
import c9 from '../../assets/c-logo/6.png'
import c10 from '../../assets/c-logo/9.png'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const Reviewsec = () => {
  return (
    <div class="review-section ws-section bg-5 dark-bg">
        <div class="container">
        <div class="row radius-1 p-lg-5 p-3 justify-content-around g-3">
    <div class="col-lg-6 align-self-center">
    <h2 class="ws-section_heading">Takshila VLSI Placements</h2>
    <div className='record d-flex'>
                    <div class="placements-count radius-1 mb-3">
                        <p class="placements-count-value font-bold heading-font mb-0 text-dark">5000+</p>
                         <p class="placements-count-title heading-font text-dark">Total placed</p>
                    </div>
                    <div class="placements-count radius-1 ms-lg-5 mb-3">
                        <p class="placements-count-value font-bold heading-font mb-0 text-dark">300+</p>
                         <p class="placements-count-title heading-font text-dark">Employers</p>
                    </div>
                    </div>
    </div>
    <div class="col-lg-5">
                    <img className='mb-5 radius-1' src={img} alt=''/>
                
                </div>
  </div>
  </div>
            <div class="row pb-5 text-dark">
                
                <div class="col-lg-12">
                   
                     <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} infinite={true}
                            >
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c1} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">
                                        I am Sanjay Kumar, completed the Physical Design course at Takshila Institute of VLSI Technologies, Bangalore. The training was well-structured, with supportive and knowledgeable trainers. The 24/7 tool access and regular mock interviews helped me gain confidence and practical skills. With their strong placement support, I successfully secured a position at Synopsys.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img1} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Thikkala Sanjay Kumar</h5>
                                        <h6 className='author-course'>Physical Design Engineer – Synopsys</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c2} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I recently completed the Physical Design course at Takshila Institute of VLSI Technologies. The training covered everything from basic to advanced concepts in a clear and structured way. With their guidance and support, I successfully secured a job at Synopsys.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img2} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Tata Venkata Sri Rajendra Prasad</h5>
                                        <h6 className='author-course'>Physical Design Engineer – Intel</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                   <img src={c3} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I am thankful to Takshila Institute of VLSI Technologies for providing such a great platform to start my career in the semiconductor industry. I completed training in Physical Design, where the faculty explained concepts clearly and provided strong practical exposure. The placement team was very supportive throughout the process, and with their guidance, I successfully got placed in a reputed company.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img3} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Vemula Sarika</h5>
                                        <h6 className='author-course'>Physical Design Engineer – Cadence Design Systems</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                   <img src={c4} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">My journey with Takshila Institute of VLSI Technologies has been very rewarding. The trainers were supportive and explained every concept clearly. Working on real-time projects improved my confidence and helped me gain strong practical knowledge. With their guidance, I got placed at Wipro. I am truly thankful to the Takshila team for helping me start my career in VLSI.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img4} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>P Bhaskar Reddy</h5>
                                        <h6 className='author-course'>Physical Design Engineer – Wipro Limited</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c5} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I completed my professional training in the Design and Verification course at Takshila Institute of VLSI Technologies. I got placed at Appex Semiconductors with the strong support of the Takshila management. They guided me in every aspect, and even after completing the course, the faculty continued to conduct mock interviews and practice sessions. Their constant support played a key role in my success.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img5} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Boggavarapu Ravi Sankar Gupta</h5>
                                        <h6 className='author-course'>ASIC Verification Engineer – Appex Semiconductors</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c6} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I completed the Analog Layout Design course at Takshila Institute of VLSI Technologies. The trainers were very supportive and gave individual attention to every student. With their guidance, I got placed at Tessolve Semiconductors.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img6} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Laam Jana Priya</h5>
                                        <h6 className='author-course'>Analog Layout Design Engineer – Tessolve Semiconductors</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c7} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I completed the Analog Layout Design course at Takshila Institute of VLSI Technologies. The faculty were very supportive, and their guidance helped me improve my technical knowledge. With 24/7 tool access and continuous support, I successfully got placed. I am thankful to the Takshila team for this opportunity.

</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img7} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Nerella Venkata Sai Samyuktha</h5>
                                        <h6 className='author-course'>Analog Layout Design Engineer – Tessolve Semiconductors</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c8} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I’m  PG student of NIT Silchar. I have successfully completed Analog Circuit Design training (online mode) from Takshila institute of VLSI. It was decent experience learning new technology from Takshila institute. They provide 24/7 access to required tools and experienced trainers. Overall learning wise good experience.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img8} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Ravindra Kumar Maurya</h5>
                                        <h6 className='author-course'>Analog Circuit Design Engineer – LeadIC Design</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c9} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I'm Pranavi. I completed my coaching in physical design at Bangalopre. Training was very good and we got trainers support throughout the course and the placement hrs also supported us very well.
                                        The management also helped us by conducted mock interviews and tests.
                                        </p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img9} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Merva Pranavi</h5>
                                        <h6 className='author-course'>Physical Design Engineer – HCL Tech</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box">
                                <div class="carousel-box-icon">
                                    <img src={c10} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">I completed my Analog Layout Design course online from Takshila Institute of VLSI Technologies and got placed at Insemi Technologies. The training was very good, and 24/7 lab access helped me gain strong practical skills.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    <img src={img10} alt=''/>
                                    <div className='author-detail px-3'>
                                        <h5 className='author-name'>Samyuktha Shrruthi K R</h5>
                                        <h6 className='author-course'>Analog Layout Design Engineer – Insemi Technology Services</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            

                            
                            </Carousel>

                </div>
            </div>
        
    </div>
  )
}

export default Reviewsec